module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/icon_1_excel_x32-c5186.png";